<template>
	<div class="shareMain">
		<div class="shareContent">
			<button class="inviteBtn" @click="inviteFriend">立即邀请微信好友</button>
			<div class="shareStep">
				<p class="title">分享步骤</p>
				<img src="images/share/step.png" class="stepIcon" />
				<ul class="stepFonts">
					<li>
						<p class="step">第一步</p>
						<p class="stepDo">分享给好友</p>
					</li>
					<li>
						<p class="step">第二步</p>
						<p class="stepDo">好友注册优能账号</p>
					</li>
					<li>
						<p class="step">第三步</p>
						<p class="stepDo">获得奖励金</p>
					</li>
				</ul>
			</div>
			<div class="rule">
				<p>活动规则：</p>
				<p>一、每成功邀请1位好友注册，获得1元奖励金300元封顶，奖励金可用于加油，次月起生效，每月到账奖金最高100元，3个月完成奖励。</p>
				<p>二、每月15日发放奖励金到电子油卡</p>
			</div>
		</div>
		<div class="heng"></div>
		<div class="myInvite">
			<div class="title">我的邀请</div>
			<ul class="inviteCount">
				<li>
					<p class="count">{{ share_count }}</p>
					<p class="title">成功邀请(人)</p>
				</li>
				<li>
					<p class="count">{{ share_money }}</p>
					<p class="title">获得奖励金(元)</p>
				</li>
			</ul>
			<p class="tips">邀越多赚越多</p>
		</div>
	</div>
</template>

<script>
import { getShareInfo, memberInfo } from '@/apis/share'

export default {
	data() {
		return {
			inviteCode: null,
			share_count: 0,
			share_money: 0,
		}
	},
	created() {
		memberInfo().then(res => {
			this.inviteCode = res.data.member_code
		})
		getShareInfo().then(res => {
			this.share_count = res.data.share_count
			this.share_money = res.data.share_money
		})
	},
	methods: {
		// 邀请好友
		inviteFriend() {
			var data = {
				url: `https://apitest.up-petroleum.com/#/?inviteCode=${this.inviteCode}&token=${this.token}`,
				title: '名',
				content: '内容',
			}
			share.postMessage(JSON.stringify(data));
		}
	}
}
</script>

<style scoped>
.shareMain {
	background: #fe5e2b;
}

.shareContent {
    background: url('../../../../public/images/share/invite.jpg') no-repeat;
	background-size: 100% auto;
    background-position: left top;
    padding-top: 120vw;
}

.inviteBtn {
	width: 66.933vw;
	height: 12.8vw;
	background-image: linear-gradient(90deg, #f1c47e 0%, #ffe7c1 100%);
	border-radius: 6.4vw;
	border: none;
	outline: none;
	font-size: 5.333vw;
	color: #73521f;
	display: block;
	margin: 0 auto;
}

.shareStep .title {
	font-size: 4.267vw;
	color: #fff4a4;
	text-align: center;
	margin-top: 7.867vw;
}

.stepIcon {
	width: 66.933vw;
	display: block;
	margin: 5.2vw auto 0;
}

.stepFonts {
	display: flex;
	justify-content: space-evenly;
}

.stepFonts p {
	text-align: center;
}

.stepFonts .step {
	font-size: 3.733vw;
	color: #fff4a4;
	margin-top: 2.667vw;
}

.stepFonts .stepDo {
	font-size: 3.733vw;
	color: white;
	margin-top: 2.533vw;
}

.rule {
	color: white;
	font-size: 3.733vw;
	padding: 0 4.4vw;
	text-align: justify;
	line-height: 5.6vw;
	margin-top: 6.3vw;
}

.heng {
	width: 100%;
	height: 2.133vw;
	background-color: #ffffff;
	opacity: 0.36;
	margin-top: 5.2vw;
}

.myInvite {
	margin: 4vw auto 0;
	padding: 0 4vw;
	background: url('../../../../public/images/share/inviteYuan.png') no-repeat;
	background-size: 61.866vw 42vw;
	background-position: right bottom;
}

.myInvite > .title {
	font-size: 4.533vw;
	color: #ffffff;
}

.inviteCount {
	display: flex;
	justify-content: space-between;
	margin-top: 3vw;
}

.inviteCount > li {
	width: 44.533vw;
	height: 20.266vw;
	border-radius: 1.066vw;
	background: white;
	overflow: hidden;
	text-align: center;
	display: flex;
	flex-flow: column;
	justify-content: center;
	align-items: center;
	box-shadow: 0px 0px 9px 0px rgba(48, 48, 48, 0.24);
}

.inviteCount .count {
	font-size: 4.267vw;
	color: #303133;
}

.inviteCount .title {
	font-size: 3.733vw;
	color: #303133;
	margin-top: 2.8vw;
}

.myInvite .tips {
	font-size: 3.467vw;
	color: #ffffff;
	opacity: 0.7;
	text-align: center;
	padding: 5vw 0;
}
</style>
